import { getTreatments } from '@App/services/api/TreatmentsService';
import { Treatment } from '@App/services/api/TreatmentsService/types/Treatment';
import { useEffect, useState } from 'react';

let treatments: Treatment[] = [];

export function useTreatments() {
  const [_treatments, setTreatments] = useState<Treatment[]>([]);
  useEffect(() => {
    async function fetchTreatments() {
      treatments = await getTreatments();
      setTreatments(treatments);
    }

    treatments.length === 0 && fetchTreatments();
  }, []);
  return treatments;
}
